import MolhamTabs from "components/ReuseableCompos/MolhamTabs";
import SEO from "components/Seo";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { AboutLayoutProps } from "pages/about";
import { PropsWithChildren } from "react";
import StaticSidebarContent from "../components/Faqs/FaqSidebar/StaticSidebarContent";
import CustomBreadCrumbs from "../components/ReuseableCompos/CustomBreadCrumbs";
import CustomJumbotron from "../components/ReuseableCompos/CustomJumbotron";
import useLastPath from "../customHooks/useLastPath";

// faqs section nestted layout
const StaticLayout: React.FC<PropsWithChildren<AboutLayoutProps>> = ({
  pages,
  children,
}) => {
  const { locale } = useRouter();

  const lastPath = useLastPath();
  const paths = [
    { path: "faqs", name: "faqs", label: "faqs", desc: "faqs_desc" },
    { path: "terms", name: "terms", label: "terms_and_conditions" },
    { path: "privacy", name: "privacy", label: "privacy_policy" },
    {
      path: "contact-us",
      name: "contact_us",
      label: "contact_us",
      desc: "contact_us_desc",
    },
    {
      path: "#chat-with-support",
      name: "support_team",
      desc: "chat_with_support_desc",
    },
  ];

  const content = paths.map((path) => {
    return {
      content: pages?.find((page) => page.slug === path.name) || {
        title: path.name,
        description: path.desc || path.name,
        body: path.name,
      },
      path,
    };
  });

  const staticSidebarContent = (
    <StaticSidebarContent content={content} lastPath={lastPath} />
  );
  const { t } = useTranslation("common");
  const isMobile = useMobile("md");
  const tabs = paths.map((item, i) => {
    if (i === paths.length - 1) return null;
    return {
      label: t(item.label),
      asHref: "/help/" + item.path,
    };
  });
  const filteredTabs = tabs.filter((item) => item !== null);
  const filterdPaths = paths.map((item) => item.path);
  const displayTabs = filterdPaths.includes(lastPath);
  return (
    <>
      <SEO
        title={
          lastPath === "help"
            ? t("help_center")
            : content.find((item) => item.path.path === lastPath)?.content
                ?.title?.[locale] ||
              t(content.find((item) => item.path.path === lastPath)?.path?.name)
        }
        description={
          lastPath === "help"
            ? t("help_center_desc")
            : content.find((item) => item.path.path === lastPath)?.content
                ?.description[locale] ||
              t(content.find((item) => item.path.path === lastPath)?.path?.desc)
        }
      />
      {isMobile && displayTabs && (
        <MolhamTabs
          TabsItems={filteredTabs}
          canSwipeTabs={false}
          setActiveIndex={paths.findIndex((item) => item.path === lastPath)}
          hrefTabs
        ></MolhamTabs>
      )}
      <div className="cs-sidebar-enabled pt-2 pt-sm-0 h-100">
        <div className="container-fluid px-0 container-md px-md-4 overflow-hidden h-100">
          <div className="row h-100">
            <div className="cs-sidebar col-lg-3 pt-lg-4 d-none d-lg-block px-4  ">
              {staticSidebarContent}
            </div>{" "}
            <div
              className="col-lg-9 cs-content pt-lg-0"
              // style={{ minHeight: match ? 740 : 818 }}
            >
              <div className="d-flex align-items-center">
                <CustomJumbotron
                  title={
                    lastPath === "help"
                      ? t("help_center")
                      : content.find((item) => item.path.path === lastPath)
                          ?.content?.title?.[locale] ||
                        t(
                          content.find((item) => item.path.path === lastPath)
                            ?.path?.name
                        )
                  }
                  desc={
                    lastPath === "help"
                      ? t("help_center_desc")
                      : content.find((item) => item.path.path === lastPath)
                          ?.content?.description[locale] ||
                        t(
                          content.find((item) => item.path.path === lastPath)
                            ?.path?.desc
                        )
                  }
                  p="py-4 px-0 px-4 px-lg-0"
                  breadCrumbM="my-0"
                  m="mt-0"
                  className="mt-0 border-bottom"
                  customBreadCrumbs={
                    <CustomBreadCrumbs
                      transformedLabel={(label) => {
                        if (label === "help") {
                          return t("help");
                        }
                        if (lastPath === "help") {
                          return t("help");
                        } else {
                          return (
                            content.find((item) => item.path.path === lastPath)
                              ?.content?.title[locale] ||
                            t(
                              content.find(
                                (item) => item.path.path === lastPath
                              )?.path?.name
                            )
                          );
                        }
                      }}
                    />
                  }
                />
              </div>
              <div className="container px-0 px-md-0"> {children}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StaticLayout;
